export const CHART_BAR_SELECTOR = "wm-chart-bar[data-chart-config]";
export const CHART_BAR_CONFIG_ATTRIBUTE = "data-chart-config";
export const CHART_BAR_DATA_ATTRIBUTE = "data-chart-data";

export const restoreChartBarProperties = (root: ParentNode) => {
  root.querySelectorAll<HTMLElement>(CHART_BAR_SELECTOR).forEach((chartElement) => {
    const serializedConfig = chartElement.getAttribute(CHART_BAR_CONFIG_ATTRIBUTE);
    const serializedData = chartElement.getAttribute(CHART_BAR_DATA_ATTRIBUTE);
    if (!serializedConfig || !serializedData) return;
    Object.assign(chartElement, {
      config: JSON.parse(serializedConfig),
      data: JSON.parse(serializedData),
    });
  });
};
